interface PolygonIconProps {
  active?: boolean;
}

export const PolygonIcon = ({ active = false }: PolygonIconProps) => {
  return (
    <>
      {active ? (
        <svg
          width="50"
          height="48"
          viewBox="0 0 50 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 0L49.7275 17.9656L40.2824 47.0344H9.71758L0.272532 17.9656L25 0Z"
            fill="#8A2BE2"
          />
        </svg>
      ) : (
        <svg
          width="50"
          height="48"
          viewBox="0 0 50 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.09543 18.2329L25 0.865247L48.9046 18.2329L39.7738 46.3344H10.2262L1.09543 18.2329Z"
            stroke="#8A2BE2"
            strokeWidth="1.4"
          />
        </svg>
      )}
    </>
  );
};

